import { render, staticRenderFns } from "./OnProcess.vue?vue&type=template&id=9079017e&scoped=true"
import script from "./OnProcess.vue?vue&type=script&lang=js"
export * from "./OnProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9079017e",
  null
  
)

export default component.exports